<template>
  <v-snackbar
    :model-value="show"
    :color="color"
    location="top"
    rounded="0"
    :timeout="-1"
    class="elevation-0"
  >
    <slot />

    <template #actions="{ props }">
      <slot
        name="actions"
        v-bind="{ props }"
      >
        <v-btn
          variant="text"
          v-bind="props"
          @click="$emit('close')"
        >
          <v-icon size="small" icon="$close" />
        </v-btn>
      </slot>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'AlertComponent',
  props: {
    show: { type: Boolean, default: true },
    color: { type: String, default: 'error' },
  },
  emits: ['close'],
};
</script>

<style scoped lang="less">
:deep(.v-snack__wrapper) {
  margin: 0 auto;
  top: 72px;
  max-width: none;
  width: 1200px;
}
:deep(.v-snack__content) {
  text-align: center;
}
</style>
